export default "__VITE_ASSET__30ded795__"